import { SyntheticEvent, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { setResetPasswordMethod } from "@/domains/auth/slice";
import { validateEmail } from "@/domains/auth/helpers/validateEmail";
import useResetPasswordEmailCode from "@/domains/auth/hooks/reset-password/useResetPasswordEmailCode";
import AuthResetPasswordCheckEmailCodeContainer from "@/domains/auth/containers/reset-password/method/AuthResetPasswordCheckEmailCodeContainer";
import AuthTitle from "@/domains/auth/components/AuthTitle";
import AuthResetPasswordEmail from "@/domains/auth/components/reset-password/method/AuthResetPasswordEmail";

export default function AuthResetPasswordEmailContainer() {
  const { t } = useTranslation("auth");
  const dispatch = useAppDispatch();
  const { sendError, sendCodeHandler, sendIsCompleted, setSendIsCompleted } =
    useResetPasswordEmailCode();
  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");

  useEffect(() => {
    if (email) {
      const validateError = validateEmail(email);
      if (validateError) {
        setEmailError(validateError);
        return;
      }
    }
    setEmailError("");
  }, [email]);

  const onSubmit = useCallback(
    async (e: SyntheticEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (emailError) return;
      sendCodeHandler(email);
    },
    [email, emailError, sendCodeHandler],
  );

  const backToChooseMethodHandler = useCallback(() => {
    dispatch(setResetPasswordMethod(null));
  }, [dispatch]);

  const backToInputEmailHandler = useCallback(() => {
    setEmail("");
    setEmailError("");
    setSendIsCompleted(null);
  }, []);

  if (sendIsCompleted) {
    return (
      <>
        <AuthTitle back={backToInputEmailHandler}>{t("auth.enterVerificationCode")}</AuthTitle>
        <AuthResetPasswordCheckEmailCodeContainer address={email} />
      </>
    );
  }

  return (
    <>
      <AuthTitle back={backToChooseMethodHandler}>Сброс пароля</AuthTitle>
      <AuthResetPasswordEmail
        error={emailError || sendError}
        onSubmit={onSubmit}
        onChangeEmail={setEmail}
        email={email}
      />
    </>
  );
}
